import Text from "components/Common/Text";

export function HelpBadge() {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "white",
          padding: "13px 42px",
          marginTop: 20,
          flexWrap: "wrap-reverse",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text as="C2" bold style={{ color: "black" }}>
            F9
          </Text>
          <Text as="C2" style={{ color: "#8E9191" }}>
            &nbsp; - Front 9
          </Text>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text as="C2" bold style={{ color: "black" }}>
            B9
          </Text>
          <Text as="C2" style={{ color: "#8E9191" }}>
            &nbsp; - Back 9
          </Text>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text as="C2" bold style={{ color: "black" }}>
            18
          </Text>
          <Text as="C2" style={{ color: "#8E9191" }}>
            &nbsp; - Full Eighteen
          </Text>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          alignItems: "center",
          backgroundColor: "white",
          padding: "13px 42px",
          marginTop: 1,
          flexWrap: "wrap-reverse",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text as="C2" bold style={{ color: "black" }}>
            F9P
          </Text>
          <Text as="C2" style={{ color: "#8E9191" }}>
            &nbsp; - Front 9 Presses
          </Text>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text as="C2" bold style={{ color: "black" }}>
            B9P
          </Text>
          <Text as="C2" style={{ color: "#8E9191" }}>
            &nbsp; - Back 9 Presses
          </Text>
        </div>
      </div>
    </>
  );
}
